import { render, staticRenderFns } from "./UserUnbind.vue?vue&type=template&id=ca4c2c7c&scoped=true&"
import script from "./UserUnbind.vue?vue&type=script&lang=js&"
export * from "./UserUnbind.vue?vue&type=script&lang=js&"
import style0 from "./UserUnbind.vue?vue&type=style&index=0&id=ca4c2c7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4c2c7c",
  null
  
)

export default component.exports